export default {
  state: {
    agendaUserData: {},
   
  },

  getters: {
    getAgendaUserData(state) {
      return state.agendaUserData;
    },
   
  },

  mutations: {
    setAgendaUserData(state, data) {
      const isNull = data === null;

      state.agendaUserData = {
        codigo: !isNull ? data.codigo : "",
        cpf: !isNull ? data.cpf : "",
        dtNascimento: !isNull ? data.dtNascimento : "",
        nome: !isNull ? data.nome : "",
        nomeMae: !isNull ? data.nomeMae : "",
        nomePai: !isNull ? data.nomePai : "",
        nroCartaoSaude: !isNull ? data.nroCartaoSaude : "",
        prontuario: !isNull ? data.prontuario : "",
        prontuarioFamiliar: !isNull ? data.prontuarioFamiliar : "",
        tab: !isNull ? data.tab : '0',
      };
    },

   
  },
  actions: {
    changeAgendaUserData(context, infos) {
      context.commit("setAgendaUserData", infos);
    },


  },
};
